import { faClock, faPowerOff, faQuestionCircle, faSearch, faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactTable from 'react-table-v6';
import { Col, Form, Nav, Navbar, NavDropdown, Row } from 'react-bootstrap';
import Timer from 'react-compound-timer';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { Config } from '../../../shared/config';
import { Utils } from '../../../shared/utils';
import { onSelectUserViewAction } from '../../../stores/actions/userData';
import About from '../About';
import Help from '../Help';
import { authService } from './../../../Auth.service';
import logo from './../../../img/logo.svg';
import { modalAboutOnChangeAction, modalHelpOnChangeAction } from './../../../stores/actions/modalOnChange';
import { isParametersOrVariablesUpdatedAction } from './../../../stores/actions/modelInputReader';
import { userChangeAction } from '../../../stores/actions/userData';

import headerService from './headerService';
import modelListService from '../../ModelLanding/modelListService';

import * as R from 'ramda';

import './headerStyle.scss';

const safeJsonParse = R.tryCatch(JSON.parse, R.always(null));

class Header extends Component {
    constructor(props) {
        super(props);
        let fomUser = localStorage.getItem('FOM_user');
        const session = safeJsonParse(fomUser);
        this.state = {
            searchCustomerText: '',
            userdata: session && session.userdata.details,
            showCustomerList: false,
            customerList: [],
            loading: false,
            showPagination: false,
            showCustomerSearch: false,
        };
        this.logout = this.logout.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.tableRowClick = this.tableRowClick.bind(this);
        this.setCustomerWrapperRef = this.setCustomerWrapperRef.bind(this);
        this.authService = new authService();
        this.modelListService = new modelListService();
        this.headerService = new headerService();
    }

    /**
     * Component will mount
     */
    componentDidMount() {
        const { userdata } = this.state;
        let customerId = null;
        let customerName = '';
        let nullParam = { target: { value: '' } };
        let ingestFileLocation = '';

        this.setState({
            searchCustomerText: customerName,
            customerSelected: false,
        });

        document.addEventListener('mousedown', this.handleClickOutside);
        if (this.state.userdata) {
            if (this.state.userdata.role === Config.user.role.customer) {
                customerId = userdata.customerId;
                ingestFileLocation = userdata.ingestFileLocation;
                this.setState({
                    createButtonStatus: true,
                    selectedCustomerId: userdata.customerId,
                });
                this.getModelList(customerId, ingestFileLocation);
                this.customerSearch(nullParam, 'autosearch');
            } else {
                // ADMIN AND CONSULTANT
                const recentCustomer = localStorage.getItem('FOM_recent_customer');
                if (recentCustomer) {
                    this.customerSearch(nullParam, 'autosearch');
                }
                if (this.state.userdata.role === Config.user.role.admin) {
                    this.loadMasterModelDetails();
                }
            }
        }
    }

    /**
     * Component will mount
     */
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    /**
     * Navigation to list
     */
    navigateToList = () => {
        this.props.setSelectedUser(null);
        this.props.history.push('/model/list');
    };

    /**
     * Navigation to admin
     */
    navigateToAdmin = () => {
        this.props.setSelectedUser(null);
        this.props.history.push('/admin');
    };

    /**
     * Rendering ui elements
     */
    render() {
        const {
            userdata,
            searchCustomerText,
            showCustomerList,
            customerList,
            loading,
            showPagination,
            showCustomerSearch,
        } = this.state;
        let showHelp = false;
        let showAbout = false;
        const displayCustomerList = showCustomerList ? 'd-block' : 'd-none';
        if (
            this.props &&
            this.props.modalHelp.payload &&
            // todo: clean this nested mess up!
            this.props.modalHelp.payload.status
        ) {
            showHelp = true;
        }

        if (this.props && this.props.modalAbout.payload && this.props.modalAbout.payload.status) {
            showAbout = true;
        }

        let uploadFilesProgress = null; //<div className="uploadFilesProgress">3 files uploading (100% completed)</div>;
        if (this.props && this.props.uploadFilesChange && this.props.uploadFilesChange.uploadFilesPayload) {
            const uploadFilesData = this.props.uploadFilesChange.uploadFilesPayload.uploadFilesData;
            if (uploadFilesData) {
                const progress = Utils.summarizeUploadFilesProgress(uploadFilesData);
                if (progress.uploadingFileCount > 0) {
                    const files = 'file' + (progress.uploadingFileCount > 1 ? 's' : '');
                    const message = `${progress.uploadingFileCount} ${files} uploading (${progress.percentComplete}% completed)`;
                    uploadFilesProgress = <div className="uploadFilesProgress">{message}</div>;
                }
            }
        }

        const showCustomerNameDropDown =
            showCustomerSearch ||
            userdata.role == Config.user.role.admin ||
            userdata.role == Config.user.role.consultant ||
            (userdata.role == Config.user.role.customer && customerList.length > 1);

        return (
            <>
                <div>{showHelp ? <Help /> : null}</div>
                <div>{showAbout ? <About /> : null}</div>
                <Row className="header-outer">
                    <Navbar expand="lg" className="navbar w-100">
                        <Navbar.Brand onClick={this.navigateToList}>
                            {userdata && userdata.role === 'CUSTOMER' ? (
                                // <img className="branding" src={user.companyLogo ? user.companyLogo :logo} alt="Therigy Logo"/>
                                <div
                                    className="customer-branding-logo"
                                    style={{
                                        backgroundImage: `url(${userdata.companyLogo ? userdata.companyLogo : logo})`,
                                    }}
                                ></div>
                            ) : (
                                <img className="branding" src={logo} alt="Therigy Logo" />
                            )}
                        </Navbar.Brand>
                        <Col xs={8} md={6}>
                            {userdata ? (
                                <Row>
                                    {showCustomerNameDropDown == true ? (
                                        <Col xs={12} md={10} lg={6}>
                                            <Form.Control
                                                className="input-search"
                                                type="text"
                                                placeholder="Customer Name"
                                                onChange={(e) => {
                                                    this.customerSearchEvent(e);
                                                }}
                                                value={searchCustomerText}
                                                autoComplete="none"
                                            />
                                            <FontAwesomeIcon icon={faSearch} className="customer-search-icon" />
                                            <div
                                                className={`model-search-box ${displayCustomerList}`}
                                                ref={this.setCustomerWrapperRef}
                                            >
                                                <ReactTable
                                                    columns={[
                                                        {
                                                            Header: 'Customer Name',
                                                            accessor: 'customerName',
                                                            width: '25vw',
                                                        },
                                                    ]}
                                                    //manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                                                    data={customerList}
                                                    loading={loading} // Display the loading overlay when we need it
                                                    noDataText="No Customers Found"
                                                    minRows={customerList.length}
                                                    showPagination={showPagination}
                                                    pageSize={customerList.length}
                                                    className="-highlight h-100 cursor-pointer"
                                                    getTrProps={(state, rowInfo) => {
                                                        return {
                                                            onClick: () => {
                                                                this.tableRowClick(rowInfo);
                                                            },
                                                        };
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                    ) : null}
                                </Row>
                            ) : null}
                        </Col>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="mr-auto justify-content-end">{uploadFilesProgress}</Nav>
                            <Nav className="justify-content-end header-rbox">
                                <Nav.Item className="user-box">
                                    <div className="right-header-user-box ">
                                        <div className="user-details">
                                            <span className="spa-user-name">
                                                {userdata.firstName} {userdata.lastName}
                                            </span>
                                            <span className="spa-user-role">{` / ` + userdata.role}</span>
                                            {userdata && userdata.customerName ? (
                                                <span className="spa-user-role">{` / ` + userdata.customerName}</span>
                                            ) : null}
                                        </div>
                                    </div>
                                </Nav.Item>
                                <Nav.Item>
                                    <NavDropdown
                                        title={
                                            <FontAwesomeIcon className="header-icon" icon={faUserCircle} size="2x" />
                                        }
                                        id="basic-nav-dropdown"
                                    >
                                        <NavDropdown.Item className="menu-item" onClick={this.logout}>
                                            Logout{' '}
                                            {
                                                <span className="list-icon">
                                                    <FontAwesomeIcon className="align-right" icon={faPowerOff} />
                                                </span>
                                            }
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav.Item>
                                <Nav.Item>
                                    <NavDropdown
                                        title={
                                            <FontAwesomeIcon
                                                className="header-icon"
                                                icon={faQuestionCircle}
                                                size="2x"
                                            />
                                        }
                                        id="basic-nav-dropdown"
                                    >
                                        <NavDropdown.Item className="menu-item" onClick={this.navigateToSupport}>
                                            Contact Support
                                        </NavDropdown.Item>
                                        <NavDropdown.Item className="menu-item" onClick={this.navigateToKnowledge}>
                                            Knowledge Network
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link>
                                        <FontAwesomeIcon className="header-icon" icon={faClock} size="2x" />
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className="timer-box">
                                        <AppTimerCounting />
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </Row>
            </>
        );
    }

    /**
     * Show help component
     * */
    showHelp = () => {
        this.props.setModalHelpOpen({ status: true });
    };

    /**
     * Show about component
     * */
    showAbout = () => {
        this.props.setModalAboutOpen({ status: true });
    };

    navigateToSupport = () => {
        window.open('https://cps.com/our-technology/therigy-vista/', '_blank', 'noopener noreferrer');
    };

    navigateToKnowledge = () => {
        window.open('http://knowledge.therigy.com/', '_blank', 'noopener noreferrer');
    };

    /**
     * Logout
     * @param evt event
     */
    logout(evt) {
        if (evt) {
            evt.preventDefault();
        }
        this.props.setSelectedUser(null);
        this.authService.setLogout();

        // walkme user data setting
        if (window.walkme) {
            window.walkme = {
                userId: undefined,
                email: undefined,
                fullName: undefined,
            };
        }

        this.props.history.push('/login');
    }

    /**
     * Set customer wrap reference
     * @param {*} node node
     */
    setCustomerWrapperRef(node) {
        this.customerWrapperRef = node;
    }

    customerSearchEvent(evt, source) {
        this.setState({ showCustomerSearch: true });
        this.customerSearch(evt, source);
    }

    /**
     * Search customers based on the input
     */
    customerSearch(evt, source) {
        this.setState(
            {
                searchCustomerText: evt.target.value,
                showCustomerList: source ? false : true,
                loading: true,
            },
            function () {
                if (!this.state.searchCustomerText) {
                    this.props.updateUser({});
                    this.setState({
                        createButtonStatus: false,
                        modelData: [],
                    });
                }

                if (this.state.searchCustomerText != null) {
                    this.modelListService.getCustomerList(this.state.searchCustomerText).then((res) => {
                        if (res && res.status === 'Success' && res.data && res.data.length) {
                            this.setState(
                                {
                                    loading: false,
                                    customerList: res.data,
                                },
                                () => {
                                    if (source && localStorage.getItem('FOM_recent_customer')) {
                                        let sessionCustomer = JSON.parse(localStorage.getItem('FOM_recent_customer'));
                                        let customer = res.data.find(
                                            (item) => sessionCustomer.customerId === item.customerId,
                                        );
                                        if (customer) {
                                            // Checking same customer id exist in the api response
                                            this.tableRowClick(customer, source);
                                        }
                                    }
                                },
                            );
                        } else {
                            this.setState({
                                loading: false,
                                showCustomerList: source ? false : true,
                                customerList: [],
                            });
                        }
                    });
                } else {
                    this.props.updateUser({});
                    this.setState({
                        loading: false,
                        customerList: [],
                    });
                }
            },
        );
    }

    tableRowClick(rowInfo, source) {
        if (
            (this.state.userdata.role === Config.user.role.consultant ||
                this.state.userdata.role === Config.user.role.admin) &&
            !source
        ) {
            localStorage.setItem('FOM_recent_customer', JSON.stringify(rowInfo.original));
        }
        let rowData = source ? rowInfo : rowInfo.original;
        this.setState({
            createButtonStatus: true,
        });
        this.setState({
            searchCustomerText: rowData.customerName,
            showCustomerList: false,
            customerId: rowData.customerId,
        });
        this.props.updateUser(rowData);
        this.getModelList(rowData.customerId, rowData.ingestFileLocation);
        this.props.history.push('/model/list');
    }

    /**
     * Load the model list
     */
    getModelList(customerId, ingestFileLocation) {
        this.setState({
            selectedCustomerId: customerId,
            ingestFileLocation: ingestFileLocation,
        });
        this.props.setVariablesUpdated(false);
    }

    /**
     * Master Details loading for admin
     */
    loadMasterModelDetails() {
        this.modelListService.getMasterModel(this.state.searchCustomerText).then((res) => {
            if (res && res.status === 'Success' && res.data) {
                let customerId = this.state.userdata.customerId;
                let masterModelObj = {
                    modelId: res.data.modelId,
                    versionId: res.data.versionId,
                    customerId: customerId,
                };
                this.setState({
                    masterModel: masterModelObj,
                });
                localStorage.setItem('FOM_master_model', JSON.stringify(masterModelObj));
            }
        });
    }

    /**
     * Invoke if clicked on outside of element.
     */
    handleClickOutside(event) {
        if (this.customerWrapperRef && !this.customerWrapperRef.contains(event.target)) {
            this.setState({ showCustomerList: false });
        }
    }
}

/**
 * Mapping redux state into props
 */
const MapStateToProps = (state) => {
    return {
        userData: state.userChangeAction,
        modalHelp: state.modalHelpOnChange,
        modalAbout: state.modalAboutOnChange,
        uploadFilesChange: state.uploadFilesAction,
    };
};

const MapDispatchToProps = (dispatch) => {
    return {
        updateUser: (params) => dispatch(userChangeAction(params)),
        setModalHelpOpen: (params) => dispatch(modalHelpOnChangeAction(params)),
        setModalAboutOpen: (params) => dispatch(modalAboutOnChangeAction(params)),
        setSelectedUser: (params) => dispatch(onSelectUserViewAction(params)),
        setVariablesUpdated: (params) => dispatch(isParametersOrVariablesUpdatedAction(params)),
    };
};

Header.propTypes = {
    history: PropTypes.object.isRequired,
    userData: PropTypes.object,
    setSelectedUser: PropTypes.func,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }),
    modalHelp: PropTypes.shape({
        payload: PropTypes.shape({
            status: PropTypes.bool,
        }),
    }),

    modalAbout: PropTypes.shape({
        payload: PropTypes.shape({
            status: PropTypes.bool,
        }),
    }),
    updateUser: PropTypes.func,
    uploadFilesChange: PropTypes.shape({
        uploadFilesPayload: PropTypes.shape({
            uploadFilesData: PropTypes.array,
        }),
    }),
    setModalHelpOpen: PropTypes.func,
    setModalAboutOpen: PropTypes.func,
    setVariablesUpdated: PropTypes.func,
};

export default connect(MapStateToProps, MapDispatchToProps)(withRouter(Header));

const withTimer =
    // eslint-disable-next-line react/display-name
    (timerProps) => (WrappedComponent) => (wrappedComponentProps) =>
        (
            <Timer {...timerProps}>
                {(timerRenderProps) => <WrappedComponent {...wrappedComponentProps} timer={timerRenderProps} />}
            </Timer>
        );

class AppTimer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sessionLength: localStorage.getItem('FOM_user_session_length')
                ? JSON.parse(localStorage.getItem('FOM_user_session_length'))
                : null,
        };

        this.headerService = new headerService();
        this.authService = new authService();
    }

    /**
     * Component did mount
     */
    componentDidMount() {
        const { setCheckpoints, setTime, start, reset } = this.props.timer;
        this.subscription = this.authService.setResetTimer().subscribe((res) => {
            if (res) {
                reset();
            }
        });
        //To check timer expire
        setCheckpoints([
            {
                time: Config.api.timer.resetRequestTime,
                callback: () => {
                    //Show confirmation on 2mints before timer expires
                    swal({
                        title: 'Continue Session?',
                        text: Config.api.timer.expiryMessage,
                        icon: 'warning',
                        dangerMode: true,
                        timer: Config.api.timer.resetRequestTime - 500,
                        buttons: ['Cancel', 'Reset Token'],
                    }).then((willDelete) => {
                        if (willDelete) {
                            this.headerService.refreshToken().then((res) => {
                                if (res && res.status === 'Success') {
                                    //Refreshing token & timer reseting
                                    reset();
                                }
                            });
                        }
                    });
                },
            },
            {
                time: 0,
                callback: () => {
                    this.authService.setLogout();
                    this.props.history.push('/login');
                },
            },
        ]);
        setTime(this.state.sessionLength);
        start();
    }

    componentWillUnmount() {
        this.props.timer.stop();
    }

    /**
     * Timer ui rendering
     */
    render() {
        return (
            <>
                <div onClick={this.props.timer.reset}>
                    <Timer.Hours formatValue={this.formatValue} />:
                    <Timer.Minutes formatValue={this.formatValue} />:
                    <Timer.Seconds formatValue={this.formatValue} />
                </div>
            </>
        );
    }

    formatValue(value) {
        return (value / 100).toFixed(2).slice(-2);
    }
}

AppTimer.propTypes = {
    history: PropTypes.object.isRequired,
    timer: PropTypes.shape({
        setCheckpoints: PropTypes.func,
        setTime: PropTypes.func,
        start: PropTypes.func,
        reset: PropTypes.func,
        stop: PropTypes.func,
    }),
};
/**
 * Setup timer defult set
 */
const AppTimerCounting = withTimer({
    direction: 'backward',
    initialTime: localStorage.getItem('FOM_user_session_length')
        ? JSON.parse(localStorage.getItem('FOM_user_session_length'))
        : null,
    startImmediately: false,
})(withRouter(AppTimer));
